import React from 'react';
import { LazySellerPagePjmBanner } from '@fiverr-private/upmarket_banners';
import { BannerWrapper } from '../components/BannerWrapper';

export const PjmBanner = () => (
    <BannerWrapper>
        <LazySellerPagePjmBanner />
    </BannerWrapper>
);
